<template>
  <div id="reassurance">
    <div class="px-5" data-aos="fade-up" data-aos-duration="900">
      <div class="row row-reas">
        <div class="col-reas">
          <img src="../images/Indicateurs.svg" v-set-alt>
          <p class="raleway-reg-p13 text-center">{{ $t("Reassurance.two") }}</p>
        </div>
        <div class="col-reas">
          <img src="../images/PGM.svg" v-set-alt>
          <p class="raleway-reg-p13 text-center">{{ $t("Reassurance.three") }}</p>
        </div>
        <div class="col-reas">
          <img src="../images/experiences.svg" v-set-alt>
          <p class="raleway-reg-p13 text-center">{{ $t("Reassurance.four") }}</p>
        </div>
        <div class="col-reas">
          <img src="../images/securite.svg" v-set-alt>
          <p class="raleway-reg-p13 text-center">{{ $t("Reassurance.six") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: 'reassurance',
  }
</script>


<style lang="scss" scope='app/assets/stylesheets/components/reassurance'>

</style>
